'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let StorageType = /*#__PURE__*/function (StorageType) {
  StorageType["SESSION_STORAGE"] = "sessionStorage";
  StorageType["LOCAL_STORAGE"] = "localStorage";
  return StorageType;
}({});
let Keyspace = /*#__PURE__*/function (Keyspace) {
  Keyspace["GUID"] = "guid";
  Keyspace["REQUEST_UUID"] = "request_uuid";
  return Keyspace;
}({});
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const NARVARJS_NAMESPACE = 'narvarjs';
const NAMESPACE_SEPERATOR = ':';
const localStorage = (() => {
  if (typeof window === 'undefined') return undefined;
  try {
    // reading the localStorage property can throw if we're in an iframe
    // see: https://stackoverflow.com/questions/67645164
    return window.localStorage;
  } catch (err) {
    return undefined;
  }
})();
let inMemoryGuid;
var Storage = (function () {
  let storageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StorageType.LOCAL_STORAGE;
  let keySpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Keyspace.GUID;
  const storage = Object.freeze({
    get: errorCallback => {
      if (!localStorage && inMemoryGuid) return inMemoryGuid;
      try {
        const unparsedData = window[storageType].getItem([NARVARJS_NAMESPACE, keySpace].join(NAMESPACE_SEPERATOR));
        if (!unparsedData) return null;
        inMemoryGuid = JSON.parse(unparsedData);
        return inMemoryGuid;
      } catch (err) {
        errorCallback(err);
        return null;
      }
    },
    set: (data, errorCallback) => {
      inMemoryGuid = data;
      try {
        window[storageType].setItem([NARVARJS_NAMESPACE, keySpace].join(NAMESPACE_SEPERATOR), JSON.stringify(data));
      } catch (err) {
        errorCallback(err);
      }
    },
    isExpired: errorCallback => {
      const {
        dateCreated = null
      } = storage.get(errorCallback) || {};
      return dateCreated ? Date.now() - new Date(dateCreated.toString()).getTime() > ONE_DAY_MS : true;
    },
    isEmpty: errorCallback => {
      return !storage.get(errorCallback);
    }
  });
  return storage;
});

exports.Keyspace = Keyspace;
exports.StorageType = StorageType;
exports["default"] = Storage;
